import axios from 'axios'

const call = axios.create({
  adapter: 'fetch',
})

// call.interceptors.response.use(response => {
//   return response
// })

export default call
